import { createSlice } from "@reduxjs/toolkit";

export const stickersSlice = createSlice({
  name: "stickers",
  initialState: {
    activeSrc: "",
    name: "",
    size: "",
    sticker: {},
    recentlyUsed: []
  },
  reducers: {
    setActiveStickersSrc: (state, action) => {
      state.activeSrc = action.payload.dataUrl;
      // state.name = action.payload.dataUrl.name;
      // state.size = action.payload.dataUrl.size;
      state.sticker = action.payload.sticker;
    },
    setRecentlyUsed: (state, action) => {
      // Check if the action.payload is already in the state.recentlyUsed array
      const index = state.recentlyUsed.findIndex(item => item.description === action.payload.description);

      // If it's not present, add it to the array
      if (index === -1) {
        if (state.recentlyUsed.length < 10) {
          // If the array length is less than 10, simply add the new item at the end
          state.recentlyUsed = [...state.recentlyUsed, action.payload];
        } else {
          // If the array length is 10, remove the oldest item (first item) and add the new item at the end
          state.recentlyUsed = [...state.recentlyUsed.slice(1), action.payload];
        }
      } else {
        // If the item is already present, remove it from its current position and place it at the end
        const updatedList = [...state.recentlyUsed.slice(0, index), ...state.recentlyUsed.slice(index + 1), action.payload];
        state.recentlyUsed = updatedList;
      }
      state.sticker = {};

    },
  },
});

// Action creators are generated for each case reducer function
export const { setActiveStickersSrc, setRecentlyUsed } = stickersSlice.actions;

export default stickersSlice.reducer;
